exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav {\n\theight: 90px!important;\n}\n\n@media only screen and (max-width: 600px) {\n\tnav {\n\t\theight: 60px!important;\n\t}\n\t\n\tnav img {\n\t\tdisplay: none;\n\t}\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 0